// import { useCallback } from "react";
// import { useSelector } from "react-redux";
// import { ROUTES } from "../utils/constants";
// import { selectCurrentCluster } from "../../store/slices/currentClusterSlice";
// import { AuthPrimary } from "../types/enums";


// export const useAuthRoute = (): (() => string) => {
//   const currentCluster = useSelector(selectCurrentCluster);

//   const isMiniApp =
//     typeof window !== "undefined" &&
//     !!window.Telegram?.WebApp?.initData &&
//     window.Telegram?.WebApp?.initData.length > 0;

//   const getRoute = useCallback((): string => {
//     if (isMiniApp) {
//       return ROUTES.TELEGRAM_LOGIN;
//     }

//     if (!currentCluster) {
//       return ROUTES.EMAIL_LOGIN;
//     }

//     switch (currentCluster.authPrimary) {
//       case AuthPrimary.EMAIL:
//         return ROUTES.EMAIL_LOGIN;
//       case AuthPrimary.MAX:
//         return ROUTES.MAX_LOGIN;
//       case AuthPrimary.TELEGRAM:
//       default:
//         return ROUTES.TELEGRAM_LOGIN;
//     }
//   }, [currentCluster, isMiniApp]);

//   return getRoute;
// };


// src/common/hooks/useAuthRoute.ts
import { useCallback } from "react";
import { ROUTES } from "../utils/constants";

export const useAuthRoute = (): (() => string) => {
  const getRoute = useCallback((): string => {
    // ВРЕМЕННО: всегда email
    return ROUTES.EMAIL_LOGIN;
  }, []);

  return getRoute;
};